import { inject, ref } from "vue";

export function useDeviceFingerprinting() {
    const emitter = inject<any>("mitt");
    const fingerprint = ref<any>(null);

    emitter.on("seonLoaded", () => initiateSeon());

    function initiateSeon() {
        if (typeof seon === "undefined") {
            return;
        }

        try {
            seon.init();

            seon.getSession({
                geolocation: {
                    canPrompt: false,
                },
                networkTimeoutMs: 2000,
                fieldTimeoutMs: 2000,
                region: "eu",
                silentMode: true,
            }).then(function (session: any) {
                if (session) {
                    fingerprint.value = session;
                }
            });
        } catch {
            // SEON fingerprinting is best-effort; ignore initialization failures.
        }
    }

    return {
        fingerprint,
    };
}
